import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import trans from 'counterpart'
import { Col } from 'reactstrap'
import styled from 'styled-components'
import { ButtonOrange } from '../../../components/Button'
import {
  allInPriceSelector,
  allInPriceLinesSelector,
  additionPriceLinesSelector,
  accoPriceLinesSelector,
  resourceInReservationSelector,
  discountSelector,
  reservationSelector
} from '../selectors'
import { handleReservationReceiptSubmit } from '../actions'
import ReceiptContext from '../../../contexts/ReceiptContext'
import { getPreference } from '../../../selectors/preferenceSelectors'

const MobileButtonWrapper = styled(Col)`
  background: #fff;
  padding: 10px;
  @media (min-width: 768px) {
    display: none;
  }
`

class ReservationReceipt extends Component {
  state = {
    disabled: false
  }

  getAllInPrice = () => {
    const { reservation } = this.props
    const { total } = reservation.bill_lines.find(line => line.bill_line_type === 70)
    if (!total) {
      return 'Geen prijs gevonden.'
    }
    return this.addZeros(total.toFixed(2).replace('.', ','))
  }

  getPrice (line) {
    return this.addZeros(line.total.toFixed(2).replace('.', ','))
  }

  handleOnSubmit = (toggle) => {
    this.setState({ disabled: true })
    this.props.handleSubmit()
      .then((result) => {
        this.setState({ disabled: false })
        if (!result) return toggle()
        if (moment(this.props.arrival, 'YYYY-MM-DD').subtract(28, 'days') < moment()) {
          return this.props.history.push(`${trans('routes.payment_request')}?resort=${result.resort_id}`)
        }
        return this.props.history.push(`${trans('routes.reservation_confirm')}?resort=${result.resort_id}`)
      })
      .catch(() => {
        this.setState({ disabled: false })
        return toggle()
      })
  }

  addZeros = (total) => {
    if (total.substring(total.indexOf(','), total.length).length < 2) {
      total += '0'
      return this.addZeros(total)
    }
    return total
  }

  showQuantity (line) {
    if (line.quantity <= 1) return false
    if (line.cash_flow_rule_name.split(' ').join('').toLowerCase() === 'lokaleheffingen') {
      return false
    }
    return true
  }

  render () {
    const {
      accoPriceLines,
      allInPrice,
      discount,
      properties,
      reservation,
      arrival
    } = this.props
    const fromPrice = allInPrice + Math.abs(discount)

    return (
      <ReceiptContext.Consumer>
        {values => (
          <div className='row'>
            <div className='col-sm-12'>
              {(reservation.isFetching && (
                <div className='p-2'>{`${trans('status.loading_reservation')} ...`}</div>
              ))}
              {(reservation.total_price && (
                <>
                  <div className='bg-receipt'>
                    <ul className='list-unstyled mb-0 pt-1 pr-1 pl-1 pb-0'>
                      {accoPriceLines.map(reservedResource => (
                        <li className='row' key={reservedResource.resource_id}>
                          <div className='col-5'>
                            <h5 className='text-lato text-info'>{reservedResource.name}</h5>
                          </div>
                          <div className='col-3 text-right px-0'>
                            {(fromPrice > allInPrice && (
                              <del className='text-muted font-italic'>{fromPrice.toFixed(2).replace('.', ',')}</del>
                            ))}
                          </div>
                          <div className='col-4 text-right pl-0'>
                            {this.getAllInPrice()}
                          </div>
                        </li>
                      ))}
                      <li className='mt-1'>
                        <div className='text-black mb-0'><p><strong>{trans('pricing.all_in_help')}</strong></p></div>
                      </li>
                      {reservation.bill_lines.filter(line => line.bill_line_type === 10).map(line => (
                        <li className='row' key={line.resource_id}>
                          <div className='col-9'>
                            {line.cash_flow_rule_name}
                          </div>
                          <div className='col-3 text-right pl-0'>
                            <span>
                              {this.getPrice(line)}
                            </span>
                          </div>
                        </li>
                      ))}
                    </ul>
                    <div className={`locale-${trans('locale')}`}>
                      {(reservation.resort_id && (reservation.resort_id === 2041) && properties.reservation_resort_info) && (
                        <div className=' mb-0 pl-1 pr-1 pb-1 pt-0' dangerouslySetInnerHTML={{ __html: properties.reservation_resort_info }} />
                      )}
                      {(reservation.resort_id && (reservation.resort_id === 21) && reservation.offer && [29, 31, 32, 34].includes(reservation.offer.resource_id) && properties.reservation_camping_info) && (
                        <div className=' mb-0 pl-1 pr-1 pb-1 pt-0' dangerouslySetInnerHTML={{ __html: properties.reservation_camping_info }} />
                      )}
                      {(reservation.resort_id && (reservation.resort_id === 21) && reservation.offer && ![29, 31, 32, 34].includes(reservation.offer.resource_id) && (reservation.arrival_date.includes('2017') === false)) && (
                        (this.props.reservation.criteria.resource_id !== '29') && (this.props.reservation.criteria.resource_id !== '30') && (this.props.reservation.criteria.resource_id !== '31') && (this.props.reservation.criteria.resource_id !== '32') && (this.props.reservation.criteria.resource_id !== '34') && (
                          <div className=' mb-0 pl-1 pr-1 pb-1 pt-0' dangerouslySetInnerHTML={{ __html: properties.reservation_vakantiepark_info }} />
                        )
                      )}
                      {(reservation.resort_id && (reservation.resort_id === 22) && properties.reservation_dierenbos_info) && (
                        <div className=' mb-0 pl-1 pr-1 pb-1 pt-0' dangerouslySetInnerHTML={{ __html: properties.reservation_dierenbos_info }} />
                      )}
                    </div>

                    <div className='row mx-0 total'>
                      <div className='col-6 px-0 p-1'>
                        {trans('pricing.total_amount')}
                      </div>
                      <div className='col-6 px-0'>
                        <div className='p-1 text-right pricetag float-right'>
                          <span className='h3'>{this.getAllInPrice()}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <MobileButtonWrapper xs='12'>
                    <ButtonOrange disabled={this.state.disabled} onClick={() => this.handleOnSubmit(values.toggle)}>
                      {moment(arrival, 'YYYY-MM-DD').subtract(28, 'days') < moment() && trans('button.reservation_confirmation_and_pay')}
                      {moment(arrival, 'YYYY-MM-DD').subtract(28, 'days') >= moment() && (this.props.properties.buttonLabel || 'Reserveren')}
                    </ButtonOrange>
                  </MobileButtonWrapper>
                </>
              ))}
            </div>
          </div>
        )}
      </ReceiptContext.Consumer>
    )
  }
}

ReservationReceipt.propTypes = {
  allInPrice: PropTypes.number,
  accoPriceLines: PropTypes.array,
  arrival: PropTypes.string,
  history: PropTypes.object,
  handleSubmit: PropTypes.func,
  discount: PropTypes.number,
  properties: PropTypes.object,
  reservation: PropTypes.object
}

const mapStateToProps = state => ({
  arrival: getPreference('arrival')(state),
  resource: resourceInReservationSelector(state),
  allInPrice: allInPriceSelector(state),
  allInPriceLines: allInPriceLinesSelector(state),
  additionPriceLines: additionPriceLinesSelector(state),
  accoPriceLines: accoPriceLinesSelector(state),
  discount: discountSelector(state),
  reservation: reservationSelector(state)
})

const mapDispatchToProps = dispatch => ({
  handleSubmit: () => dispatch(handleReservationReceiptSubmit())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReservationReceipt))
